import Vue from "vue";
import App from "./App.vue";
import {BootstrapVue,BootstrapVueIcons} from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueResource from "vue-resource";
import VueRouter from "vue-router";
import DonationReplyPage from "./components/DonationReplyPage.vue";
import ErrorPage from "./components/ErrorPage.vue";
import DonationCardPage from "./components/DonationCardPage.vue";
import Loading from "vue-loading-overlay"; //component
import "vue-loading-overlay/dist/vue-loading.css"; //style
import VuejsDialog from "vuejs-dialog";
import VuejsDialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js"; // only needed in custom components
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// include the default style
import "vuejs-dialog/dist/vuejs-dialog.min.css";

Vue.use(BootstrapVue);
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(VuejsDialog);
Vue.use(BootstrapVueIcons);
Vue.use(require('moment'));
Vue.use(ElementUI);


Vue.config.productionTip = false;
// assign apiurl
Vue.http.options.root = process.env.VUE_APP_APIURL;
Vue.component("Loading", Loading);

const routes = [
  {
    path: "/",
    component: DonationReplyPage
  },
  {
    path: "/card",
    component: DonationCardPage
  },
  {
    path: "/reply",
    component: DonationReplyPage
  },
  {
    name: "ERROR",
    path: "/message",
    component: ErrorPage
  }
];

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
  mode: "history",
  routes // (缩写) 相当于 routes: routes
});
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
